(function () {
  if (window.__posloyWidgetFixInit) return;
  window.__posloyWidgetFixInit = true;

  function isStickyBarStuck() {
    return document.body.classList.contains('sticky-bar-stuck');
  }

  /**
   * @param {ShadowRoot} shadowRoot
   */
  function updateReopenBtnPosition(shadowRoot) {
    var btn = /** @type {HTMLElement | null} */ (shadowRoot.querySelector('#posloy-reopen-btn[data-position="left"]'));
    if (!btn) return;
    if (isStickyBarStuck()) {
      btn.style.setProperty('bottom', '90px', 'important');
    } else {
      btn.style.removeProperty('bottom');
    }
  }

  function watchShadowRoot(host) {
    var shadowRoot = host.shadowRoot;
    if (!shadowRoot) return;

    updateReopenBtnPosition(shadowRoot);

    var shadowObserver = new MutationObserver(function () {
      updateReopenBtnPosition(shadowRoot);
    });
    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });

    var bodyClassObserver = new MutationObserver(function () {
      updateReopenBtnPosition(shadowRoot);
    });
    bodyClassObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function findHostAndWatch() {
    var existing = document.getElementById('posloy-shadow-host');
    if (existing) {
      watchShadowRoot(existing);
      return true;
    }
    return false;
  }

  if (findHostAndWatch()) return;

  // Coalesce mutation bursts into one lookup per frame to keep main-thread cost low
  var scheduled = false;
  var bodyObserver = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      var host = document.getElementById('posloy-shadow-host');
      if (host) {
        bodyObserver.disconnect();
        watchShadowRoot(host);
      }
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
